import React from 'react';

const footerStyle = {
  fontSize: '10px',
  color: '#999',
  background: '#f5f5f5',
  padding: '12px 16px',
  borderRadius: '8px',
  textAlign: 'center',
  lineHeight: '1.5',
  marginTop: '16px',
};

const buttonStyle = {
  display: 'inline-block',
  background: '#266ab3',
  color: '#fff',
  padding: '8px 16px',
  borderRadius: '6px',
  fontSize: '12px',
  marginTop: '8px',
  textDecoration: 'none',
  border: 'none',
  cursor: 'pointer',
};

function DisclaimerFooter({ text }) {
  return (
    <div style={footerStyle}>
      <p style={{ margin: 0 }}>
        {text || 'These results are estimates for educational purposes only and do not constitute financial, investment, tax, or insurance advice. Our system is designed for accuracy but automated calculations can contain errors. Your actual situation may differ based on factors not captured here. For verified, personalized recommendations, speak with a Certified Financial Planner at AplusWealth Inc. We accept no liability for decisions made based on these results. Ashkon Pour-Heidary, CFP, HBSc, LLQP and Ali Pihani, BSc, LLQP \u2014 AplusWealth Inc.'}
      </p>
      <a
        href="/#/book"
        style={buttonStyle}
      >
        Book a free call with a Certified Financial Planner &rarr;
      </a>
    </div>
  );
}

export default DisclaimerFooter;
